export class UpdateAmountAndTermRequest {
  amount: number;
  term: number;
  email: string;
}
